import { PaddedSurface as Surface } from "App/global-style";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { ProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesInterface";
import { productionYears } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesUtils/productionYears";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Props {
  formProps: FormikProps<ProductIntroFormValues>;
}

export const Details = (props: Props): React.ReactElement => {
  const { formProps } = props;
  const { getText } = useTexts();

  return (
    <Surface>
      <Select
        id="year"
        name="year"
        label={getText("valuablesform.label.productionyear")}
        hint={getText("valuablesform.hint.productionyear")}
        options={[placeholder, ...productionYears]}
        error={getError("year", formProps)}
        large
      />
    </Surface>
  );
};

const placeholder = {
  id: "placeholder-year",
  label: "",
  value: "",
};
